import { generateRandomHash } from 'Utils/generateRandomHash';

/**
 * Generate a new cart session hash and set it in the cookie
 * @param {function} setCookie - function to set cookie
 * @returns {void}
 */
export const generateCartSessionHash = (setCookie) => {
  const hash = generateRandomHash(32);
  const expDate = new Date();
  expDate.setFullYear(expDate.getFullYear() + 1);
  setCookie(hash, expDate);
};
